import icLogoLight from "./../../assets/svg/ic_logo.svg";
import DropdownLang from "./../../layouts/DropdownLang";
import ToastU from "../../components/ui/ToastU";
import Utils from './../../utils'
import Config from './../../config'

const Wrapper = ({children}) => {
    const organization = JSON.parse(localStorage.getItem('organization'));
    
    return (
        <div className="container-fluid vh-100">
            <div className="row h-100">
                <div className="col-md-6 d-flex flex-column justify-content-between p-5">
                    <div className="d-flex flex-column">
                        <div className="d-flex flex-row">
                            <img src={icLogoLight} alt="logo" className="wh-30 me-1 hover-cursor"/>
                            <span className="bold fg-dark font-18 me-3">{Config.APP_NAME}</span>
                            <DropdownLang className={'border'}/>
                        </div>
                        <span className="fg-dark mt-2">{organization?.name}</span>
                    </div>
                    { children }
                    <div className="d-flex flex-column">
                        <small className="me-2">Copyright © {Utils.getYear()} Ähli hukuklar goralan</small>
                        <span className="font-12 fg-gray medium">{Config.VERSION}</span>
                    </div>
                </div>
                <div className="col-md-6 d-none d-md-block p-0">
                    <div className="right-panel">
                        <div className="overlay">
                            <small>Powered by <span className="fw-semibold">Alem Tilsimat</span></small>
                            <h2 className="display-5 mt-5 mb-1">Hasap</h2>
                            <h2 className="display-5 mb-1">Dolandyryş</h2>
                            <h2 className="display-5 mb-5">Ulgamy</h2>
                        </div>
                    </div>
                </div>
            </div>
            <ToastU/>    
        </div>
    );
}

export default Wrapper;